import React from 'react';
import { useI18n } from '@infrastructure/i18n';
import styled from 'styled-components';
import { themeGet } from '@styled-system/theme-get';
import { A, Button } from '@xingternal/rebranding-adapter';
import { Card } from '@xingternal/winery-ui/lib/Card';
import { Text } from '@xingternal/winery-ui/lib/Text';
import { XTS_EMAIL } from '@config/app.constants';
import { MEDIA_SIZES } from '@helpers/styles';
import { ErrorMessage, ErrorWrapper, Icon } from '../components/errorFragments';

export const i18nContact = {
  main: 'XTS_ERROR_LIGHTBOX_SUBTITLE',
  button: 'XTS_ERROR_LIGHTBOX_CTA',
  heading: 'XTS_ERROR_LIGHTBOX_TITLE',
} as const;

const ErrorTitle = styled(Text).attrs(() => ({
  color: 'primaryText',
}))`
  font-size: ${themeGet('fontSizes.4')};
  margin-top: ${themeGet('space.6')};
  ${MEDIA_SIZES.MEDIUM_AND_MORE} {
    font-size: ${themeGet('fontSizes.6')};
  }
`;

const ErrorCard = styled(Card)`
  display: flex;
  flex-direction: column;
  padding: ${themeGet('space.8')} ${themeGet('space.6')};
  align-items: center;
  max-width: 552px;
`;

const ContactBoundary = () => {
  const { i18n } = useI18n<typeof i18nContact>();
  const main = i18n(i18nContact.main);
  const heading = i18n(i18nContact.heading);
  const button = i18n(i18nContact.button);

  return (
    <ErrorWrapper>
      <ErrorCard boxShadow={2}>
        <Icon color="eyeCatcher" />
        <ErrorTitle>{heading}</ErrorTitle>
        <ErrorMessage>{main}</ErrorMessage>
        <Button
          as={A}
          mt={6}
          variant="tertiary"
          data-testid="email-link"
          href={`mailto:${XTS_EMAIL}`}
        >
          {button}
        </Button>
      </ErrorCard>
    </ErrorWrapper>
  );
};

export { ContactBoundary };
